import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Eyebrow, SectionHeading } from "../common/Type";
import { Reveal } from "../common/Reveal";
import ServiceDiagram from "../common/ServiceDiagram";
import { serviceModules } from "../../lib/content";

export default function ServiceModules() {
  return (
    <section className="relative py-24 md:py-32 bg-kv-bg2/40 border-y border-kv-steel/10" data-testid="section-services">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <Eyebrow className="mb-5">Capabilities</Eyebrow>
            <SectionHeading className="max-w-2xl">A connected operating model, not a stack of tools.</SectionHeading>
          </div>
          <Link to="/services" data-testid="services-view-all" className="kv-link font-body text-sm text-kv-grey hover:text-kv-off whitespace-nowrap">
            View all services →
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {serviceModules.map((s, i) => (
            <Reveal key={s.id} delay={(i % 3) * 0.08}>
              <Link
                to="/services"
                data-testid={`service-module-${s.id}`}
                className="group relative block kv-card p-8 md:p-9 h-full"
              >
                <div className="h-20 w-24 mb-8 opacity-80 group-hover:opacity-100 transition-opacity">
                  <ServiceDiagram type={s.diagram} className="h-full w-full" />
                </div>
                <div className="flex items-start justify-between gap-3">
                  <h3 className="font-display text-xl md:text-2xl font-medium tracking-tight text-kv-off">{s.title}</h3>
                  <ArrowUpRight className="h-5 w-5 text-kv-steel group-hover:text-kv-electric transition-colors shrink-0 mt-1" />
                </div>
                <p className="mt-4 font-body text-sm md:text-base text-kv-grey leading-relaxed">{s.summary}</p>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
